import Modal from "react-bootstrap/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import {useEffect, useRef, useState} from "react";

import ModalRoutesFlyTippingTable from "./ModalRoutesFlyTippingTable";
import axiApi from "ApiCaller";
import {toLowCaseCleanSpaces} from "core/utils/Texts";
import {publishEvent} from "core/eventsConnector";

const ModalRoutesFlyTippingSelect = ({show, setShow, multiple = false, chosenIn = [], subtitle = ""}) => {
    const items = useRef({
        all: [],
        showed: [],
        chosen: [],
        checked: [],
    });

    const [itemsShow, setItemsShow] = useState([]);
    const [checked, setChecked] = useState([]);

    useEffect(() => {
        if (chosenIn.length) {
            items.current.checked = chosenIn.map((it) => it.id);
            setChecked([...items.current.checked]);
            setItemsShow([...items.current.all]);
        }
    }, [chosenIn]);

    useEffect(() => {
        axiApi.get(`/api/distribution/routes/fly-tippings/`).then((resp) => {
            items.current.all = [...resp.data.items];
            items.current.showed = [...resp.data.items];
            setItemsShow([...resp.data.items]);
        });
    }, []);

    const onSearch = (e) => {
        let items_ = items.current.all.filter((it) => items.current.checked.includes(it.id));
        const valueSearched = toLowCaseCleanSpaces(e.target.value);
        if (valueSearched) {
            let filter_ = items.current.all.filter(
                (_item) => toLowCaseCleanSpaces(_item.name).includes(valueSearched) && !items.current.checked.includes(_item.id),
            );
            items.current.showed = [...items_, ...filter_];
        } else {
            items.current.showed = [...items.current.all];
        }
        setItemsShow([...items.current.showed]);
    };

    const handleClose = () => {
        setShow(false);
    };
    const handleAccept = () => {
        setShow(false);
        if (multiple) {
            const items_ = items.current.all.filter((item) => items.current.checked.includes(item.id));
            publishEvent("routesflytipping:modalselect:change", items_);
        } else {
            publishEvent("routesflytipping:modalselect:change", items.current.showed[items.current.chosen[0]]);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} animation={true} dialogClassName="modal-dialog-scrollable">
            <Modal.Header closeButton className="preview-canvas mb-0">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="sack-xmark" />
                </div>
                <div className="preview-title d-inline-flex align-items-center">
                    <Modal.Title className="d-inline-flex ms-1">
                        <div>
                            <div className="h4 ms-0">Rutas</div>
                            <div className="h5 ms-0">
                                <small>{subtitle}</small>
                            </div>
                        </div>
                    </Modal.Title>
                    <form className="d-inline-flex ms-2" role="search">
                        <input
                            className="form-control border-end-0 rounded-0"
                            type="search"
                            placeholder="Nombre"
                            aria-label="Search"
                            onChange={onSearch}
                        />
                        <span className="input-group-text bg-white border-start-0 rounded-0" id="modal-searcher-groups">
                            <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                        </span>
                    </form>
                </div>
            </Modal.Header>
            <Modal.Body>
                <ModalRoutesFlyTippingTable items={items} itemsShow={itemsShow} checked={checked} setChecked={setChecked} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Descartar
                </Button>
                <Button variant="primary" onClick={handleAccept}>
                    Seleccionar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalRoutesFlyTippingSelect;
